import { ApiClient } from '../api-client';
import { HttpParams } from '@angular/common/http';
import { AssignmentIdentity } from '@k2/common/entities-state/types';

export class FinanceBillingEndpoint {
  constructor(private api: ApiClient) {
  }

  fetchUndatedSOs = (requestParams: {
    filters: {
      'filters[client]': string,
      'filters[service][]': number[],
      'filters[paymentFrequencyType][]': PaymentFrequencyType[],
      'filters[status]'?: string,
      'filters[product]'?: string,
      'filters[description]'?: string,
      offset: number,
      limit: number
    }
  }) => {
    return this.api.get('/assignment-service-transaction?context=undated_sales_transactions',
      new HttpParams({ fromObject: requestParams.filters })
    );
  };

  sendSOsForDating = (data: { ids: number[], paymentDueAt: string }) => {
    return this.api.patch('/assignment-service-transaction/undated-sales-orders', data);
  };

  updateTransactionsInvoicesOneoffSODating = (
    { clientId, assignmentId }: AssignmentIdentity,
    transactionId: string,
    serviceId: number,
    data: any
  ) => {
    return this.api.patch(
      `/clients/${clientId}/assignment/${assignmentId}/service/${serviceId}/transactions/invoices/oneoff/${transactionId}`,
      { ...data, ...{ context: 'undated_sales_transactions' } }
    );
  };

  fetchTransactionsInvoicesRecurringForm = (
    { clientId, assignmentId }: AssignmentIdentity,
    transactionId: string,
    serviceId: number
  ) => {
    return this.api.getWithoutCache(
      `/clients/${clientId}/assignment/${assignmentId}/service/${serviceId}/transactions/invoices/recurring/${transactionId}`
    );
  };

  updateTransactionsInvoicesRecurringSODating = (
    { clientId, assignmentId }: AssignmentIdentity,
    transactionId: string,
    serviceId: number,
    data: any
  ) => {
    return this.api.patch(
      `/clients/${clientId}/assignment/${assignmentId}/service/${serviceId}/transactions/invoices/recurring/${transactionId}`,
      { ...data, ...{ context: 'undated_sales_transactions' } }
    );
  };
}

export enum PaymentFrequencyType {
  ONE_OFF = "ONE OFF",
  RECURRING = "RECURRING",
  RECURRING_ORDER = "RECURRING ORDER"
}
